import { Component, DOCUMENT, inject } from '@angular/core';

import { OfferButtonComponentBase } from './offer-button-component-base';

/**
 * @stable
 */
@Component({
    standalone: true,
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[data-offer-id],[data-campaign-id]:not(a[ds-button])',
    template: '<ng-content />',
})
export class OfferButtonComponent extends OfferButtonComponentBase {
    private readonly _doc = inject(DOCUMENT);

    constructor() {
        super();
        this.doc = this._doc;
    }
}
